import { QueryParametersSchema, QueryParameterSchema, QueryParametersKey } from './types';

import { searchQueryParameter } from './searchQueryFilter';
import { pageNumberParameter } from './pageNumberParameter';
import { pageSizeParameter } from './pageSizeParameter';
import { statusFilterQueryFilter } from './statusFilterQueryFilter';
import { intakeTermFilterQueryFilter } from './intakeTermFilterQueryFilter';
import { sortFilterQueryFilter } from './sortFilterQueryFilter';
import { campusFilterQueryFilter } from './campusFilterQueryFilter';

const schema: QueryParametersSchema = {
  searchQuery: searchQueryParameter,
  pageNumber: pageNumberParameter,
  pageSize: pageSizeParameter,
  status: statusFilterQueryFilter,
  intakeTermIds: intakeTermFilterQueryFilter,
  campusIds: campusFilterQueryFilter,
  sort: sortFilterQueryFilter,
};

const parameters = Object.entries(schema).map(([key, parameter]) => {
  return { key: key as keyof QueryParametersSchema, ...(parameter as QueryParameterSchema<QueryParametersKey>) };
});

export const get = <Key extends QueryParametersKey>(key: Key): QueryParametersSchema[Key] => schema[key];

export const queryParametersSchema = {
  get,
  parameters,
};
